const TAXON_TYPE = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  TIP: 'TIP',
  DIGITAL_ITEM: 'DIGITAL_ITEM',
  COURSE: 'COURSE',
  EMAIL_CAPTURE: 'EMAIL_CAPTURE',
  UNKNOWN: 'UNKNOWN',
};

const TAXON_TYPE_DISPLAY_NAME_FOR_PERSON = {
  [TAXON_TYPE.SUBSCRIPTION]: 'Subscription',
  [TAXON_TYPE.TIP]: 'Tip',
  [TAXON_TYPE.DIGITAL_ITEM]: 'Digital Item',
  [TAXON_TYPE.COURSE]: 'Course',
  [TAXON_TYPE.EMAIL_CAPTURE]: 'Email capture',
};

const TAXON_TYPE_DISPLAY_NAME_FOR_RELATED_PERSON = {
  [TAXON_TYPE.SUBSCRIPTION]: 'Subscriber',
  [TAXON_TYPE.TIP]: 'Tip',
  [TAXON_TYPE.DIGITAL_ITEM]: 'Digital Item',
  [TAXON_TYPE.COURSE]: 'Course attendee',
  [TAXON_TYPE.EMAIL_CAPTURE]: 'Email capture',
};

export {
  TAXON_TYPE,
  TAXON_TYPE_DISPLAY_NAME_FOR_PERSON,
  TAXON_TYPE_DISPLAY_NAME_FOR_RELATED_PERSON,
};
